import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CrudTranslationService} from '../../../../shared/services/crud-translation.service';
import {AbstractCrudEditComponent} from '@shared/library/crud-library/abstract-crud-edit.component';
import {ApiFactoryService} from '@shared/services/api-factory.service';
import {AlertService} from '@shared/services/alert.service';

@Component({
  selector: 'app-translation-edit',
  templateUrl: './translation-edit.component.html',
  styleUrls: ['./translation-edit.component.scss']
})
export class TranslationEditComponent extends AbstractCrudEditComponent {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    private httpcrud: CrudTranslationService,
    protected apifactory: ApiFactoryService,
    protected alertService: AlertService
  ) {
    super(activatedRoute, router, apifactory, httpcrud, alertService);

    // Create form fields
    this.fields = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'keyword',
                type: 'input',
                templateOptions: { label: 'Keyword', required: true }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'prefix',
                type: 'input',
                templateOptions: { label: 'Prefix', required: true }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'format',
                type: 'input',
                templateOptions: { label: 'Format' }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'description',
                type: 'input',
                templateOptions: { label: 'Description' }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'multiline',
                type: 'checkbox',
                defaultValue: true,
                templateOptions: {label: 'Multiline'}
              }
            ]
          },
          {
            template: '<div class="col-12 pb-2"><strong>English</strong></div>',
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'label_en',
                type: 'editor'
              }
            ]
          },
          {
            template: '<div class="col-12 pb-2"><strong>French</strong></div>',
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'label_fr',
                type: 'editor',
                templateOptions: { label: 'Translation' }
              }
            ]
          },
          {
            template: '<div class="col-12 pb-2"><strong>German</strong></div>',
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'label_de',
                type: 'editor',
                templateOptions: { label: 'Translation' }
              }
            ]
          }
        ]
      }
    ];

    this.createSectionTitle = 'Create translation';
    this.updatePrefixTitle = 'Edit translation: ';
    this.labelFieldName = 'keyword';

    this.entityrooturl = '/admin/translation';

  }

}
